import Form          from 'antd/lib/form';
import Icon           from 'antd/lib/icon';
import React          from 'react';
import Tooltip       from 'antd/lib/tooltip';
import filterDOMProps from 'uniforms/filterDOMProps';

export default function wrapField ({
    colon,
    error,
    errorMessage,
    id,
    info,
    label,
    labelCol,
    required,
    showInlineError,
    wrapperCol
}, children) {
    const labelNode = !!label && (
        <span style={{marginBottom: -30, whiteSpace: 'normal', textAlign: 'left'}}>
            {label}
            {!!info && (
                <span>
                    &nbsp;
                    <Tooltip title={info}>
                        <Icon type="question-circle-o" />
                    </Tooltip>
                </span>
            )}
        </span>
    );

    return (
        <Form.Item
            colon={false}
            hasFeedback
            help={showInlineError && error && errorMessage}
            htmlFor={id}
            label={labelNode}
            labelCol={labelCol}
            required={required}
            style={{marginBottom: 12, marginTop: 20, textAlign: 'left'}}
            validateStatus={error ? 'error' : undefined}
            wrapperCol={wrapperCol}
        >
            {children}
        </Form.Item>
    );
}

filterDOMProps.register(
    'colon',
    'labelCol',
    'wrapperCol'
);



// WEBPACK FOOTER //
// ./src/components/UI/uniforms/wrapField.jsx